import React from 'react';
import Helmet from 'react-helmet';

interface ContentMetatagsProps {
  title: string
  description: string
  canonicalUrl: string
}

export function ContentMetatags(props: ContentMetatagsProps): React.JSX.Element {
  const { title , description, canonicalUrl} = props;
  return (
    <Helmet
      meta={[
        { name: 'title', content: title },
        { name: 'description', content: description },
        { name: 'robots', content: 'index,follow' }
      ]}
    >
      <link rel="canonical" href={canonicalUrl} />
    </Helmet>
  );
}
